import { render } from "./DateHistoryView.vue?vue&type=template&id=08087de0&scoped=true"
import script from "./DateHistoryView.vue?vue&type=script&lang=js"
export * from "./DateHistoryView.vue?vue&type=script&lang=js"

import "./DateHistoryView.vue?vue&type=style&index=0&id=08087de0&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08087de0"]])

export default __exports__